import React, { useEffect, useState, useCallback, useRef } from "react";
import { Icon } from "@iconify/react";
import { Button } from "../../../components/ui/button";
import { Card, CardHeader, CardContent } from "../../../components/ui/card";
import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from "../../../components/ui/tabs";
import { Calendar } from "../../../components/ui/calendar";
import {
  AppSelect,
  AppSearchSelect,
  AppInput,
  AppSearchSectionSelect,
} from "../../../components/appComponents";
import Common from "../../../helper/common";
import {
  DayOfWeekEnum,
  BookingStatusEnum,
  PaymentStatusEnum,
  AmenityTypeEnum,
  BookingModeEnum,
  ToCSharpFormat,
  TimeFormat,
  DateminFormat,
  respEnum,
  ClubPrivacyTypeEnum,
} from "../../../constants/appConstant";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import moment from "moment";
import Swal from "sweetalert2";
import { FormikSearchSelect } from "../../../components/formik-components";
import AddCustomer from "../../clubCustomers/components/addCustomer";

const AddAmenityBooking = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("sessionBased");

  // Helper functions
  const getInitialStartDateTime = () => {
    const now = moment();
    // Round up to the next 30-minute interval
    const remainder = 30 - (now.minute() % 30);
    const roundedUp = now.add(remainder, "minutes").seconds(0);
    return roundedUp.format(DateminFormat + "THH:mm");
  };

  const getInitialEndDateTime = (start) => {
    return moment(start)
      .add(30, "days")
      .endOf("day")
      .format(DateminFormat + "THH:mm");
  };

  // Session Based fields
  const [bookingDate, setBookingDate] = useState(
    moment().format(DateminFormat)
  );
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");

  // Package Based fields
  const initialStartDateTime = getInitialStartDateTime();
  const [startDateTime, setStartDateTime] = useState(initialStartDateTime);
  const [endDateTime, setEndDateTime] = useState(
    getInitialEndDateTime(initialStartDateTime)
  );

  const [selectedDays, setSelectedDays] = useState([0, 1, 2, 3, 4, 5, 6]); // All days selected by default
  const [customerList, setCustomerList] = useState([]);
  const [amenityList, setAmenityList] = useState([]);
  const [bankAccountList, setBankAccountList] = useState([]);
  const [selectedBankAccount, setSelectedBankAccount] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedAmenity, setSelectedAmenity] = useState(null);
  const [numberOfPersons, setNumberOfPersons] = useState(1);
  const [note, setNote] = useState("");
  const [charges, setCharges] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [paymentStatus, setPaymentStatus] = useState(PaymentStatusEnum.Paid);
  const [receivedAmount, setReceivedAmount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const formikRef = useRef();
  const [player_Id, setPlayer_Id] = useState(null);

  const [open, setOpen] = useState(false);

  debugger;
  const _onCustomerAdded = useCallback(async (id) => {
    setPlayer_Id(id);
    await getCustomers();
  }, []);
  const _addCustomer = useCallback(() => (
    <AddCustomer
      id={undefined}
      onClose={_onCustomerAdded}
      open={open}
      setOpen={setOpen}
      bookingModal={true}
    />
  ));

  useEffect(() => {
    getCustomers();
    getAmenities();
    getBankAccounts();
  }, []);

  useEffect(() => {
    calculateTotal();
  }, [charges, discountAmount, paymentStatus]);

  useEffect(() => {
    // When startDateTime changes, update endDateTime
    if (startDateTime) {
      setEndDateTime(
        moment(startDateTime)
          .add(30, "days")
          .endOf("day")
          .format(DateminFormat + "THH:mm")
      );
    }
  }, [startDateTime]);

  const getCustomers = async () => {
    try {
      const response = await Common.ApiService.getInstance().request(
        "ClubPlayersddl",
        {},
        "Get",
        false
      );
      if (response?.data) {
        setCustomerList(response.data);
      }
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  const getAmenities = async () => {
    try {
      const response = await Common.ApiService.getInstance().request(
        "GetAmenityWiseFacilitiesddl",
        {},
        "Get",
        false
      );
      if (response?.data) {
        setAmenityList(response.data);
      }
    } catch (error) {
      console.error("Error fetching amenities:", error);
    }
  };

  const getBankAccounts = async () => {
    try {
      const response = await Common.ApiService.getInstance().request(
        "GetClubPaymentTypes"
      );
      if (response?.data) {
        setBankAccountList(response.data);
      }
    } catch (error) {
      console.error("Error fetching bank accounts:", error);
    }
  };

  const calculateTotal = () => {
    // Ensure discount doesn't exceed charges
    const validDiscountAmount = Math.min(discountAmount, charges);

    // Calculate subtotal ensuring it's never negative
    const subtotal = Math.max(0, charges - validDiscountAmount);

    // Update discount if it was corrected
    if (validDiscountAmount !== discountAmount) {
      setDiscountAmount(validDiscountAmount);
    }

    if (paymentStatus === PaymentStatusEnum.Paid) {
      setReceivedAmount(subtotal);
    } else if (paymentStatus === PaymentStatusEnum.Un_Paid) {
      setReceivedAmount(0);
    }
  };

  const handleDayToggle = (dayId) => {
    setSelectedDays((prev) =>
      prev.includes(dayId) ? prev.filter((d) => d !== dayId) : [...prev, dayId]
    );
  };

  const handleStartDateTimeChange = (newDateTime) => {
    const newDate = moment(newDateTime).startOf("day");
    const today = moment().startOf("day");
    if (!newDate.isSame(today, "day")) {
      setStartDateTime(
        moment(newDateTime)
          .startOf("day")
          .format(DateminFormat + "THH:mm")
      );
    } else {
      setStartDateTime(newDateTime);
    }
  };

  const handleAmenityChange = (selectedValue) => {
    debugger;
    setSelectedAmenity(selectedValue);
    if (selectedValue) {
      if (selectedValue) {
        setCharges(selectedValue.defaultcharges || 0);
      }
    } else {
      setCharges(0);
    }
  };

  // Add discount validation functions
  const handleDiscountChange = (value) => {
    const numericValue = parseFloat(value) || 0;

    // Ensure discount doesn't exceed charges
    if (numericValue > charges) {
      toast.error("Discount amount cannot be greater than charges");
      setDiscountAmount(charges);
      return;
    }

    // Ensure discount is not negative
    if (numericValue < 0) {
      setDiscountAmount(0);
      return;
    }

    setDiscountAmount(numericValue);
  };

  const handleDiscountKeyDown = (e) => {
    // Allow only numbers, decimal point, backspace, delete, tab, escape, enter, arrow keys
    if (
      !(
        (
          (e.keyCode >= 48 && e.keyCode <= 57) || // 0-9
          (e.keyCode >= 96 && e.keyCode <= 105) || // numpad 0-9
          e.keyCode === 8 || // backspace
          e.keyCode === 9 || // tab
          e.keyCode === 27 || // escape
          e.keyCode === 13 || // enter
          e.keyCode === 46 || // delete
          e.keyCode === 110 || // decimal point (numpad)
          e.keyCode === 190 || // decimal point
          (e.keyCode >= 37 && e.keyCode <= 40)
        ) // arrow keys
      )
    ) {
      e.preventDefault();
    }

    // Prevent multiple decimal points
    if (
      (e.keyCode === 110 || e.keyCode === 190) &&
      e.target.value.includes(".")
    ) {
      e.preventDefault();
    }
  };

  const handleDiscountBlur = () => {
    // Final validation on blur
    if (discountAmount > charges) {
      toast.error("Discount amount cannot be greater than charges");
      setDiscountAmount(charges);
    }

    // Ensure subtotal is never negative
    const subtotal = charges - discountAmount;
    if (subtotal < 0) {
      setDiscountAmount(charges);
      toast.error("Subtotal cannot be negative");
    }
  };

  const validateSessionBasedForm = () => {
    if (!bookingDate) return "Please select a booking date";
    if (!startTime) return "Please select start time";
    if (!endTime) return "Please select end time";
    if (endTime <= startTime) return "End time must be after start time";
    if (!selectedAmenity) return "Please select an Facility";
    if (!selectedCustomer && !player_Id) return "Please select a customer";
    if (!numberOfPersons || numberOfPersons < 1)
      return "Please enter a valid number of persons";
    if (!charges || charges <= 0) return "Please enter valid charges";
    if (discountAmount > charges)
      return "Discount amount cannot be greater than charges";
    const subtotal = charges - discountAmount;
    if (subtotal < 0) return "Subtotal cannot be negative";
    return null;
  };

  const validatePackageBasedForm = () => {
    if (!startDateTime) return "Please select start date & time";
    if (!endDateTime) return "Please select end date & time";
    if (moment(endDateTime).isBefore(moment(startDateTime))) {
      return "End date & time must be after start date & time";
    }
    if (selectedDays.length === 0) return "Please select at least one day";
    if (!selectedAmenity) return "Please select an amenity";
    if (!selectedCustomer && !player_Id) return "Please select a customer";
    if (!numberOfPersons || numberOfPersons < 1)
      return "Please enter a valid number of persons";
    if (!charges || charges <= 0) return "Please enter valid charges";
    if (discountAmount > charges)
      return "Discount amount cannot be greater than charges";
    const subtotal = charges - discountAmount;
    if (subtotal < 0) return "Subtotal cannot be negative";
    return null;
  };

  const handleSubmit = async (createAndPrint = false) => {
    try {
      setIsLoading(true);

      let validationError = null;
      if (activeTab === "sessionBased") {
        validationError = validateSessionBasedForm();
      } else {
        validationError = validatePackageBasedForm();
      }

      if (validationError) {
        toast.error(validationError);
        setIsLoading(false); // Stop loading
        return;
      }

      const subtotal = charges - discountAmount;

      if (paymentStatus !== PaymentStatusEnum.Un_Paid) {
        if (!selectedBankAccount) {
          toast.error(
            "Please select a bank account for paid or partial bookings."
          );
          setIsLoading(false);
          return;
        }
        if (receivedAmount > subtotal) {
          toast.error("Received amount cannot be greater than the subtotal.");
          setIsLoading(false);
          return;
        }
        if (
          paymentStatus === PaymentStatusEnum.Partial_Paid &&
          receivedAmount >= subtotal
        ) {
          toast.error(
            "For partial payments, received amount must be less than the subtotal."
          );
          setIsLoading(false);
          return;
        }
      }

      const bookingData = {
        id: 0,
        playerId: selectedCustomer ?? player_Id,
        clubamenityId: selectedAmenity.value,
        type:
          activeTab === "sessionBased"
            ? AmenityTypeEnum.Session_Based
            : AmenityTypeEnum.Package_Based,

        // Session Based fields
        bookingdate:
          activeTab === "sessionBased"
            ? moment(bookingDate).format(ToCSharpFormat)
            : null,
        starttime: activeTab === "sessionBased" ? startTime : null,
        endtime: activeTab === "sessionBased" ? endTime : null,

        // Package Based fields
        startdatetime:
          activeTab === "sessionBased"
            ? moment(`${bookingDate} ${startTime}`).format(ToCSharpFormat)
            : moment(startDateTime).format(ToCSharpFormat),
        enddatetime:
          activeTab === "sessionBased"
            ? moment(`${bookingDate} ${endTime}`).format(ToCSharpFormat)
            : moment(endDateTime).format(ToCSharpFormat),

        selecteddays: JSON.stringify(selectedDays),
        noofpersons: parseInt(numberOfPersons),
        bookingstatus: BookingStatusEnum.Booked, // Default status
        paymentstatus: paymentStatus,
        bookingmode: BookingModeEnum.Club_Booking,
        clubAccountId: selectedBankAccount.value,
        charges: parseFloat(charges),
        discountamount: discountAmount ? parseFloat(discountAmount) : null,
        total: subtotal,
        receivedamount: parseFloat(receivedAmount) || 0,
        remainingamount: subtotal - (parseFloat(receivedAmount) || 0),
        // isavail: true,
        // cancelreason: null,
        ispaid: paymentStatus === PaymentStatusEnum.Paid,
        note:note?.trim() ? note.trim() : null,
      };

      const response = await Common.ApiService.getInstance().request(
        "AddUpdateAmenityBooking",
        bookingData,
        "Post"
      );

      if (response?.status === respEnum.Success) {
        const successMessage = "Facility booking created successfully!";

        if (createAndPrint) {
          // For create and print, navigate to the booking details with print flag
          Swal.fire({
            title: "Success!",
            text: successMessage,
            icon: "success",
            timer: 2000,
            showConfirmButton: false,
          }).then(() => {
            // Assuming the API returns the created booking ID
            const bookingId = response?.data;
            navigate(`/app/amenitybookingdetails?id=${bookingId}&print=true`);
          });
        } else {
          Swal.fire({
            title: "Success!",
            text: successMessage,
            icon: "success",
            timer: 2000,
            showConfirmButton: false,
          }).then(() => {
            navigate("/app/amenitybookings");
          });
        }
      } else {
        toast.error(response?.message || "Error saving facility booking");
      }
    } catch (error) {
      console.error("Error submitting facility booking:", error);
      toast.error("Error submitting facility booking. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const renderPaymentDetails = () => {
    // Ensure subtotal is never negative
    const subtotal = Math.max(0, charges - discountAmount).toFixed(2);
    return (
      <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
        <h4 className="text-sm font-semibold text-[#0C1B3A] mb-4 flex items-center">
          <Icon icon="heroicons:currency-dollar" className="mr-2" />
          Payment Details
        </h4>

        <div className="space-y-4">
          <div>
            <AppInput
              type="number"
              value={charges}
              onChange={(value) => {
                const numericValue = parseFloat(value) || 0;
                if (numericValue < 0) {
                  setCharges(0);
                  return;
                }
                setCharges(numericValue);
              }}
              label="Charges *"
              min={0}
              step="0.01"
              className="mb-0"
              placeholder="Enter charges amount"
            />
          </div>

          <div>
            <AppInput
              type="number"
              value={discountAmount}
              onChange={handleDiscountChange}
              onBlur={handleDiscountBlur}
              onKeyDown={handleDiscountKeyDown}
              label="Discount Amount"
              min={0}
              max={charges}
              step="0.01"
              className="mb-0"
              placeholder="Enter discount amount"
            />
          </div>

          <div className="bg-white border border-gray-200 rounded-md p-3">
            <label className="block text-xs font-medium mb-1 text-[#0C1B3A]">
              Subtotal
            </label>
            <div className="text-lg font-bold text-[#0C1B3A]">{subtotal}</div>
          </div>

          <div className="hidden">
            <AppSelect
              value={paymentStatus}
              onChange={setPaymentStatus}
              label="Payment Status *"
              data={Common.Utility.enumToArray(PaymentStatusEnum)}
              className="mb-0"
              disabled={true}
            />
          </div>

          {paymentStatus !== PaymentStatusEnum.Un_Paid && (
            <div className="border-t pt-4 space-y-4">
              <div>
                <AppSearchSectionSelect
                  value={selectedBankAccount}
                  onChange={setSelectedBankAccount}
                  label="Bank Account *"
                  data={bankAccountList}
                  placeholder="Select Bank Account"
                  className="mb-0"
                />
              </div>

              <div>
                <AppInput
                  type="number"
                  value={receivedAmount}
                  onChange={setReceivedAmount}
                  label="Received Amount"
                  min={0}
                  step="0.01"
                  className="mb-0"
                  disabled={paymentStatus === PaymentStatusEnum.Paid}
                />
              </div>

              <div className="bg-white border border-gray-200 rounded-md p-3 hidden">
                <label className="block text-xs font-medium mb-1 text-[#0C1B3A]">
                  Remaining Amount
                </label>
                <div className="text-lg font-bold text-red-600">
                  {(subtotal - (parseFloat(receivedAmount) || 0)).toFixed(2)}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderSessionBasedContent = () => (
    <TabsContent value="sessionBased">
      <div className="pt-4">
        <Card className="border-0 shadow-sm">
          <CardContent className="p-4">
            <div className="grid grid-cols-10 gap-4">
              {/* Left Content Area - 70% */}
              <div className="col-span-12 md:col-span-7">
                <h4 className="text-sm font-semibold text-[#0C1B3A] mb-3">
                  Booking Details
                </h4>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-2 mb-3">
                  <div>
                    <label className="block text-xs font-medium mb-1 text-[#0C1B3A]">
                      Booking Date *
                    </label>
                    <AppInput
                      type="date"
                      value={bookingDate}
                      onChange={setBookingDate}
                      min={moment().format(DateminFormat)}
                      className="mb-0 h-8 text-sm"
                    />
                  </div>

                  <div>
                    <label className="block text-xs font-medium mb-1 text-[#0C1B3A]">
                      Start Time *
                    </label>
                    <AppInput
                      type="time"
                      value={startTime}
                      onChange={setStartTime}
                      className="mb-0 h-8 text-sm"
                    />
                  </div>

                  <div>
                    <label className="block text-xs font-medium mb-1 text-[#0C1B3A]">
                      End Time *
                    </label>
                    <AppInput
                      type="time"
                      value={endTime}
                      onChange={setEndTime}
                      className="mb-0 h-8 text-sm"
                    />
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-2 mb-3">
                  <AppSearchSectionSelect
                    value={selectedAmenity}
                    onChange={handleAmenityChange}
                    placeholder="Select Facility"
                    label="Facility *"
                    data={amenityList}
                    className="mb-0"
                  />

                  <AppSearchSelect
                    value={selectedCustomer ?? player_Id}
                    onChange={setSelectedCustomer}
                    placeholder="Select Customer"
                    label="Customer *"
                    data={customerList}
                    className="mb-0"
                    labelButton={
                      global.myClub?.privacyType == ClubPrivacyTypeEnum.Public
                        ? _addCustomer
                        : null
                    }
                  />

                  <AppInput
                    type="number"
                    value={numberOfPersons}
                    onChange={setNumberOfPersons}
                    label="Number of Persons *"
                    min={1}
                    max={50}
                    className="mb-0 h-8 text-sm"
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-2 mb-3">
                  <div className="flex flex-col col-span-1">
                    <label className="text-sm font-medium mb-2 mt-3 md:mt-0">Note</label>
                    <textarea
                      value={note}
                      onChange={(e) => setNote(e.target.value)}
                      maxLength={225}
                      className="w-full h-22 text-sm border rounded-lg p-2"
                      placeholder="Write your note..."
                    />
                  </div>
                </div>
              </div>

              {/* Right Payment Sidebar - 30% */}
              <div className="col-span-12 md:col-span-3">{renderPaymentDetails()}</div>
            </div>
          </CardContent>
        </Card>
      </div>
    </TabsContent>
  );

  const renderPackageBasedContent = () => (
    <TabsContent value="packageBased">
      <div className="pt-4">
        <Card className="border-0 shadow-sm">
          <CardContent className="p-4">
            <div className="grid grid-cols-10 gap-4">
              {/* Left Content Area - 70% */}
              <div className="col-span-7">
                <h4 className="text-sm font-semibold text-[#0C1B3A] mb-3">
                  Booking Details
                </h4>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-3">
                  <div>
                    <label className="block text-xs font-medium mb-1 text-[#0C1B3A]">
                      Start Date & Time *
                    </label>
                    <AppInput
                      type="datetime-local"
                      value={startDateTime}
                      onChange={handleStartDateTimeChange}
                      className="mb-0 h-8 text-sm"
                    />
                  </div>

                  <div>
                    <label className="block text-xs font-medium mb-1 text-[#0C1B3A]">
                      End Date & Time *
                    </label>
                    <AppInput
                      type="datetime-local"
                      value={endDateTime}
                      onChange={setEndDateTime}
                      className="mb-0 h-8 text-sm"
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <label className="block text-xs font-medium mb-1 text-[#0C1B3A]">
                    Select Days *
                  </label>
                  <div className="flex flex-wrap gap-1">
                    {Common.Utility.enumToArray(DayOfWeekEnum).map((day) => (
                      <Button
                        key={day.id}
                        variant={
                          selectedDays.includes(day.id) ? "default" : "outline"
                        }
                        onClick={() => handleDayToggle(day.id)}
                        className="w-22 h-7 text-md"
                        type="button"
                      >
                        {day.name}
                      </Button>
                    ))}
                  </div>
                  <p className="text-xs text-gray-500 mt-1">
                    Selected days: {selectedDays.length} of 7
                  </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-2 mb-3">
                  <AppSearchSectionSelect
                    value={selectedAmenity}
                    onChange={handleAmenityChange}
                    placeholder="Select Facility"
                    label="Facility *"
                    data={amenityList}
                    className="mb-0"
                  />

                  <AppSearchSelect
                    value={selectedCustomer ?? player_Id}
                    onChange={setSelectedCustomer}
                    placeholder="Select Customer"
                    label="Customer *"
                    data={customerList}
                    className="mb-0"
                    labelButton={
                      global.myClub?.privacyType == ClubPrivacyTypeEnum.Public
                        ? _addCustomer
                        : null
                    }
                  />

                  <AppInput
                    type="number"
                    value={numberOfPersons}
                    onChange={setNumberOfPersons}
                    label="Number of Persons *"
                    min={1}
                    max={50}
                    className="mb-0 h-8 text-sm"
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-2 mb-3">
                  <div className="flex flex-col col-span-1">
                    <label className="text-sm font-medium mb-1">Note</label>
                    <textarea
                      value={note}
                      onChange={(e) => setNote(e.target.value)}
                      maxLength={225}
                      className="w-full h-22 text-sm border rounded-lg p-2"
                      placeholder="Write your note..."
                    />
                  </div>
                </div>

              </div>

              {/* Right Payment Sidebar - 30% */}
              <div className="col-span-3">{renderPaymentDetails()}</div>
            </div>
          </CardContent>
        </Card>
      </div>
    </TabsContent>
  );

  return (
    <div className="container mx-auto p-3">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-xl font-bold text-[#0C1B3A] flex items-center">
          <Icon icon="heroicons:plus-circle" className="mr-2" />
          Create Facility Booking
        </h1>
        <Button
          variant="outline"
          onClick={() => navigate("/app/amenitybookings")}
          className="border-[#0C1B3A] text-[#0C1B3A] hover:bg-[#e8eaf0]"
        >
          <Icon icon="heroicons:arrow-left" className="mr-1" />
          Back to List
        </Button>
      </div>

      <Card className="p-4 border-0 shadow-sm">
        <Tabs defaultValue={activeTab} onValueChange={setActiveTab}>
          <TabsList className="bg-[#e8eaf0]">
            <TabsTrigger
              value="sessionBased"
              className="data-[state=active]:bg-[#0C1B3A] data-[state=active]:text-white"
            >
              Session Based
            </TabsTrigger>
            <TabsTrigger
              value="packageBased"
              className="data-[state=active]:bg-[#0C1B3A] data-[state=active]:text-white"
            >
              Package Based
            </TabsTrigger>
          </TabsList>

          {renderSessionBasedContent()}
          {renderPackageBasedContent()}

          <div className="mt-4 flex flex-col md:flex-row gap-3 justify-end">
            <Button
              variant="outline"
              onClick={() => navigate("/app/amenitybookings")}
              className="border-[#0C1B3A] text-[#0C1B3A] hover:bg-[#e8eaf0]"
            >
              <Icon icon="heroicons:x-mark" className="mr-1" />
              Cancel
            </Button>

            <Button
              onClick={() => handleSubmit(true)}
              disabled={isLoading}
              className="bg-[#0C1B3A] hover:bg-[#1a2a4e] text-white border-0"
            >
              {isLoading ? (
                <>
                  <Icon
                    icon="eos-icons:loading"
                    className="mr-2 animate-spin"
                  />
                  Processing...
                </>
              ) : (
                <>
                  <Icon icon="heroicons:printer" className="mr-1" />
                  Create & Print
                </>
              )}
            </Button>

            <Button
              onClick={() => handleSubmit(false)}
              disabled={isLoading}
              className="bg-[#0C1B3A] hover:bg-[#1a2a4e] text-white border-0"
            >
              {isLoading ? (
                <>
                  <Icon
                    icon="eos-icons:loading"
                    className="mr-2 animate-spin"
                  />
                  Processing...
                </>
              ) : (
                <>
                  <Icon icon="heroicons:check" className="mr-1" />
                  Create Booking
                </>
              )}
            </Button>
          </div>
        </Tabs>
      </Card>
    </div>
  );
};

export default AddAmenityBooking;
